import React, { useEffect, useState, useRef } from 'react'
import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
//import TableContainer from '@mui/material/TableContainer';


const columns = [
    { id: 'timestamp', label: 'Timestamp'},
    { id: 'user_email_address', label: 'Username'},
    { id: 'genset_serial_number', label: 'Genset Serial Number'},
    { id: 'change_log_type', label: 'Log Type'},
    { id: 'change_log_subtype', label: 'Log Sub Type'},
    { id: 'log_description', label: 'Description'}
];

const styles = {
    customTable : {
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0
    },
    customTableHead : {
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        fontWeight: '600',
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.01071em',
        display: 'table-cell',
        verticalAlign: 'inherit',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        textAlign: 'left',
        padding: '16px',
        color: 'rgba(0, 0, 0, 0.87)',
        position: '-webkit-sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: '#fff',
    },
    customTableBody : {
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.43',
        letterSpacing: '0.01071em',
        display: 'table-cell',
        verticalAlign: 'inherit',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        textAlign: 'left',
        padding: '16px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
    customTableBox : {
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    
    boxedContainer : {
        maxHeight:'800px',
        overflowY: 'auto',
        // '&::-webkit-scrollbar' : {
        //     height: '4px',
        //     width: '4px',
        //     background: 'gray'
        // },
        // '&::-webkit-scrollbar-track' : {
        //     background: '#f1f1f1'
        // },

        // '&::-webkit-scrollbar-thumb' : {
        //     background: '#888',
        //     borderRadius: '8px'
        // },
        // '&::-webkit-scrollbar-thumb:hover' : {
        //     background: 'rgb(30,60,114)'
        // },
        // '&::-webkit-scrollbar-thumb:horizontal' : {
        //     borderRadius: '10px'
        // }
    }

};

const ExternalWindowComponent = ({data}) => {
    
    const [socketData, setSocketData] = useState([]);
    
    useEffect(() => {
        setSocketData(data);
        const handleMessage = (event) => {
            if(event.data.type === 'initialdata'){
                setSocketData(event.data.data)
            }
        }
        window.addEventListener('message',handleMessage);
        return () => {
            window.removeEventListener('message',handleMessage);
        }
    },[data])

    const tableContainerRef = useRef(null);

    useEffect(() => {
        if(tableContainerRef.current){
            tableContainerRef.current.scrollTop = 0;
        }
    }, [socketData]);
    
    return (
        <Box style={styles.customTableBox}>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>  
                <div ref={tableContainerRef} style={styles.boxedContainer}>
                    <Table className='customTable' style={styles.customTable} stickyHeader  aria-label="sticky table">
                        <TableHead style={{display: 'table-header-group'}}>
                            <TableRow style={{
                                color: 'inherit',
                                display: 'table-row',
                                verticalAlign: 'middle',
                                outline: 0
                            }}>
                                {columns.map((column) => (
                                    <TableCell
                                    
                                    key={column.id}
                                    align={column.align}
                                    style={styles.customTableHead}
                                    >
                                    { column.label }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody style={{display: 'table-header-group'}}>
                            { socketData?.length > 0 ? socketData?.map((row,index) => {
                                let rowData  = row;
                                return (
                                    <>
                                        <TableRow style={{
                                            color: 'inherit',
                                            display: 'table-row',
                                            verticalAlign: 'middle',
                                            outline: 0,
                                            background: !index ? "#FFE5A4" : "#FFFFFF"
                                            
                                        }} role="checkbox" tabIndex={-1} key={rowData.product_id} sx={{ '& > *': { borderBottom: 'unset' } }}>
                                            {columns.map((column) => {
                                                const value = rowData[column.id];
                                                return (
                                                    <TableCell style={styles.customTableBody} key={column.id} align={column.align}>
                                                        { column.format && typeof value === 'number' ? column.format(value) :  value }
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    </>
                                );
                            }) : <TableRow><TableCell style={{fontSize:'0.85rem',height: '112px',fontWeight:'600',textAlign: 'center'}} colSpan={6}> No Data Available. </TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </div>  
            </Paper>
        </Box>  
    )
}

export default ExternalWindowComponent